"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyPlanTemplateCard = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'block',
            maxWidth: 180,
            width: '100%',
            padding: 0,
            borderRadius: 10,
        },
        paper: {
            padding: theme.spacing(3, 3, 2, 3),
            borderRadius: 10,
            height: 180,
            width: '100%',
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper,
            transition: theme.transitions.create(['box-shadow'], {
                duration: theme.transitions.duration.standard,
            }),
            boxShadow: '0 10px 20px rgba(0, 0, 0, .15), 0 3px 6px rgba(0, 0, 0, .10)',
            '&:hover': {
                boxShadow: '0 20px 40px rgba(0, 0, 0, .2)',
            },
        },
        name: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            minHeight: 40,
            lineHeight: 1.3,
        },
        length: {
            display: 'block',
            marginTop: theme.spacing(1),
            paddingBottom: 32,
        },
    });
});
var StudyPlanTemplateCard = function (_a) {
    var classNameProp = _a.className, template = _a.template, other = __rest(_a, ["className", "template"]);
    var classes = useStyles();
    return (react_1.default.createElement(core_1.ButtonBase, __assign({ disableRipple: true, className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.Paper, { className: classes.paper },
            react_1.default.createElement(core_1.Typography, { className: classes.name }, template.name || 'Untitled'),
            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.length },
                template.length,
                " days"))));
};
exports.StudyPlanTemplateCard = StudyPlanTemplateCard;
exports.default = exports.StudyPlanTemplateCard;
//# sourceMappingURL=StudyPlanTemplateCard.js.map